import { Link } from "react-router-dom"
import Title from "../components/ui/Title"
import '../styles/pages/system.scss'

const System = () => {

    return (
        <div className="page-container">
            <Title
                text="System"
                size="full"
            />
            <div className="line-container">
                <h1 className="system-captcha">
                    Please select the system you'd like to know more about.
                </h1>
                <div className="system-list">
                    <Link to='/system/at-battle'>
                        <SystemButton
                            image='./img/ss/at-1.webp'
                            text="AT Battle"
                        />
                    </Link>
                    <Link to='/system/arts'>
                        <SystemButton
                            image='./img/ss/arts-1.webp'
                            text="Arts"
                        />
                    </Link>
                    <Link to='/system/crafts'>
                        <SystemButton
                            image='./img/ss/lloyd-craft.webp'
                            text="Crafts"
                        />
                    </Link>
                    <Link to='/system/support-requests'>
                        <SystemButton
                            image='./img/ss/support-1.webp'
                            text="Support Requests"
                        />
                    </Link>
                    <Link to='/system/minigames-extra'>
                        <SystemButton
                            image='./img/ss/mini-1.webp'
                            text="Minigames &amp; Extra"
                        />
                    </Link>
                    <Link to='/system/special-shops'>
                        <SystemButton
                            image='./img/ss/equip-1.webp'
                            text="Special Shops"
                        />
                    </Link>
                </div>
            </div>
        </div>
    )
}

const SystemButton = ({image, text}) => (
    <div className="system-button"
        style={{backgroundImage: `url(${image})`}}
    >   
        <h1>
            {
                text
            }
        </h1>
    </div>
)

export default System